module.exports = __webpack_public_path__ + "static/media/whatsapp-ecosentino-logo.ee22ff12.svg";